import AddToCartArgs from "./AddToCartArgs";
import ProductOption from "./ProductOption";

export default class AddToCartBulkArgs {
    // public productArgs = new AddToCartArgs();
    // public optionList = [];
    public items: AddToCartArgs[] = [];
    public packageId = 0;
}
